import { ProductRepository } from "../Repository/ProductRepository";

export interface SetMainImageUseCase {
  invoke: (data: any) => Promise<string | undefined>;
}

export class SetMainImage implements SetMainImageUseCase {
  private galeryRepo: ProductRepository;
  constructor(_ProductRepo: ProductRepository) {
    this.galeryRepo = _ProductRepo;
  }

   invoke(data: any){
    if(!data){
        throw new Error(
            "Your todo should have at leat 2 characters."
          );
    }
    const getData = this.galeryRepo.setMainImage(data);
    return getData;
  }
}